import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import AddIcon from "@mui/icons-material/Add";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { getItemList, getItemDetail, getTransactionStatusKeyValueListByType, logItemHistory, getInvoicesList, getSalesOrderList, getAllRecordsByWarehouseId } from "../../../services/index";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import EditIcon from "@mui/icons-material/Edit";
import toast, { Toaster } from "react-hot-toast";
import { getItemHistoryLog } from "../../../services/Inventory/ItemService";
import Cookies from "universal-cookie";


const ViewItem = () => {
    let { warehouseId, id } = useParams();
    let navigate = useNavigate();
    const [logData, setLogData] = useState({});

    const [salesList, setSalesList] = useState([]);
    const [invoiceList, setInvoiceList] = useState([]);
    const [cID, setCID] = useState("");

    const [invoiceInfo, setInvoiceInfo] = useState([]);
    const [salesInfo, setSalesInfo] = useState([]);

    const [itemDetails1, setItemDetails1] = useState("");
    const [valueLoading, setValueLoading] = useState(false);
    const [data, setData] = useState([]);
    const [rows, setRows] = useState([]);
    const [search, setSearch] = useState([]);

    const [itemDetails, setItemDetails] = useState([]);
    const [dataId, setDataId] = useState();
    const [filterBy, setFilterBy] = useState("SalesOrder");
    const [filterByMenuHtml, setFilterByMenuHtml] = useState([]);
    const [statusBy, setStatusBy] = useState("All");
    const [statusByMenuHtml, setStatusByMenuHtml] = useState([]);
    const [loading, setLoading] = useState(false);
    const [itemListDetails, setItemListDetails] = useState(null);
    const [index, setIndex] = useState(0);
    const [filterText, setFilterText] = useState("");
    const [logHistoryDetails, setLogHistoryDetails] = useState([]);
    let loginData1 = new Cookies().get('loginData1');


    // const handleFilterByClick = (filter) => {
    //     setFilterBy(filter);
    //     getTransactionStatusKeyValueListByTypeCall(filter);
    // };
    const handleStatusByClick = (status) => {
        setStatusBy(status);
    };

    // const getTransactionStatusKeyValueListByTypeCall = (type) => {
    //     getTransactionStatusKeyValueListByType(type)
    //         .then((res) => {
    //             if (res.errorCode === 0) {
    //                 var temp = [];
    //                 res.responsePacket.map((item) => {
    //                     temp.push(<Dropdown.Item onClick={() => handleStatusByClick(item.value)}>{item.value}</Dropdown.Item>);
    //                 });
    //                 setStatusByMenuHtml(temp);
    //             } else {
    //             }
    //         })
    //         .catch((err) => {});
    // };

    const getRecordsID = (id) => {
        setCID(id);
        getItemDetail(id).then((res) => {
            if (res.errorCode === 0) {
                setItemDetails(res.responsePacket);
                setItemDetails1(res.responsePacket.warehouseItemsBeanList);
                setValueLoading(true);
            }
        });
    };

    const getLogHistory = (id) => {
        getItemHistoryLog(id).then((res) => {
            if (res.errorCode === 0) {
                if (res?.responsePacket?.jsonData) {
                    const data = JSON?.parse(res?.responsePacket?.jsonData);
                    setLogHistoryDetails(data);
                }
            }
        });
    };

    useEffect(() => {
        getAllItemsRecord();
        getRecordsID(id);
        getLogHistory(id);
    }, [id]);

    useEffect(() => {
        getAllItemsRecord();
    }, [filterText])

    const getAllItemsRecord = () => {
        let list_data = {
            page: index,
            size: 18,
            search: filterText,
            uuid: "",
            uuid2: ""
        };

        if (warehouseId && warehouseId !== undefined) {
            setLoading(true);
            list_data.uuid = warehouseId;
            getAllRecordsByWarehouseId(list_data).then((res) => {
                if (res.errorCode === 0) {
                    const data = res.responsePacket.data;
                    const options = data.map((d) => ({
                        ...d,
                        recordId: d.recordId,
                        title: d.title,
                    }));
                    if (index === 0) {
                        setData(options);
                        setRows(options);
                        setLoading(false);
                    }
                    else {
                        const setItemListClone = [...rows, ...res.responsePacket.data];
                        setRows(setItemListClone);
                        setData(setItemListClone);
                    }
                    setIndex(index + 1);
                    setItemListDetails({
                        recordsFiltered: res?.responsePacket?.recordsFiltered,
                        recordsTotal: res?.responsePacket?.recordsTotal,
                        total: res?.responsePacket?.total,
                    })
                }
                else {
                    setLoading(false);
                }
            });
        } else {
            setLoading(true);
            getItemList(list_data).then((res) => {
                if (res.errorCode === 0) {
                    if (index === 0) {
                        const d = res.responsePacket.data;
                        // d.reverse();
                        setData(d);
                        setRows(d);
                        setLoading(false);
                    }
                    else {
                        const setItemListClone = [...rows, ...res?.responsePacket?.data];
                        setRows(setItemListClone);
                        setData(setItemListClone);
                    }
                    setIndex(index + 1);
                    setItemListDetails({
                        recordsFiltered: res?.responsePacket?.recordsFiltered,
                        recordsTotal: res?.responsePacket?.recordsTotal,
                        total: res?.responsePacket?.total,
                    })
                }
                else {
                    setLoading(false);
                }
            });
        }
    };

    const editItems = () => {
        navigate(`/items/${itemDetails.recordId}/edit`);
        setDataId(itemDetails.recordId);
    };
    useEffect(() => {
        logItemHistory(id).then((res) => {
            if (res.errorCode === 0) {
                const d = res.responsePacket;
                setLogData(d);
            } else {
                toast(res.message);
            }
        });

        let abc = salesList.filter((a) => a.customerId === cID);
        setSalesInfo(abc);

        let abc2 = invoiceList.filter((a) => a.customerId === cID);
        setInvoiceInfo(abc2);
    }, [id]);

    let time;
    const handleSearch = (e) => {
        const { value } = e.target;
        clearTimeout(time);
        time = setTimeout(() => {
            setIndex(0);
            setFilterText(value);
        }, 500);
    };

    const searchOptions = [
        { value: "isIngredient", label: "Ingredient" },
        { value: "isPurchase", label: "Purchase" },
        { value: "isSales", label: "Sales" },
        { value: "isTaxable", label: "Taxable" },
        { value: "nonTaxable", label: "NonTaxable" },
    ];

    // const handleSearchOption = (e) => {
    //     setSearch(e);

    //     var arr1 = rows.filter((data) => data.isIngredient);
    //     var arr2 = rows.filter((data) => data.isPurchase);
    //     var arr3 = rows.filter((data) => data.isSales);
    //     var arr4 = rows.filter((data) => data.isTaxable);
    //     var arr5 = rows.filter((data) => !data.isTaxable);

    //     if (e.value === "isIngredient") {
    //         setData(arr1);
    //     }
    //     if (e.value === "isPurchase") {
    //         setData(arr2);
    //     }
    //     if (e.value === "isSales") {
    //         setData(arr3);
    //     }
    //     if (e.value === "isTaxable") {
    //         setData(arr4);
    //     }
    //     if (e.value === "nonTaxable") {
    //         setData(arr5);
    //     }
    // };

    return (
        <>
            <div className="list-column column d-print-none " style={{ width: "300px" }}>
                <div className="fill list-header topgrad d-print-none">
                    <div className="list-filter pt-3 d-flex align-items-center">
                        <Link to="/items/new" className="newListBtn">
                            <AddIcon />
                            New
                        </Link>
                        <div className="input-group paginationSearchInput listSearch">
                            <div className="input-group-prepend">
                                <span className="input-group-text" id="basic-addon1">
                                    <SearchRoundedIcon />
                                </span>
                            </div>
                            <input autoComplete="off" className="form-control" type="text" placeholder="Search..." onChange={handleSearch} />
                        </div>
                    </div>
                </div>
                <div id="scrolled_div" className="scroll-y fill body scrollbox">
                    <div className="table-responsive overflow-initial  ">
                        <table id="ember721" className="table zi-table table-hover ember-view header-fixed w-100">
                            {data && (data?.length > 0 ?
                                (<tbody>
                                    {data?.map((d, i) => (
                                        <tr key={i} className={`listTr ${id === d.recordId ? "activeRecord" : ""}`}>

                                            <td>
                                                <Link
                                                    to={warehouseId && warehouseId !== undefined ? `/items/${warehouseId}/${d.recordId}` : `/items/${d.recordId}`}
                                                    className={`${id === d.recordId ? "text-primary" : "text-grey"}`}
                                                >
                                                    <span className="titleTr mb-0">{d.title}</span>
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                    {
                                        itemListDetails &&
                                        itemListDetails?.recordsTotal >
                                        data.length && (
                                            <div className="pt-3">
                                                <button
                                                    className="btn mx-auto newListBtn"
                                                    onClick={getAllItemsRecord}
                                                >
                                                    Load More
                                                </button>
                                            </div>

                                        )}
                                </tbody>) : (<div className="my-3 text-black text-center">No Data Available!</div>)
                            )}
                        </table>
                    </div>
                </div>
            </div>

            <div className="column content-column" style={{ left: "300px" }}>
                <div className="fill1 header d-flex align-items-center p-4 justify-content-between">
                    <div className="btn-toolbar d-flex justify-content-end align-items-center ml-auto">
                        <div className="btn-group">
                            <button id="ember7700" className="tooltip-container ember-view btn btn-primary mr-0" type="button" onClick={editItems}>
                                <EditIcon />
                            </button>
                        </div>
                    </div>
                </div>
                <br />
                <Tabs className="upperTabs">
                    <TabList>
                        <Tab>Primary Details</Tab>
                        <Tab>Log History</Tab>
                        {(loginData1.username === "Gajendra" || loginData1.username === "sangeeta" || loginData1.username === "KPIS_DEVELOPER") && <Tab> Item History Log</Tab>}
                    </TabList>
                    {itemDetails && itemDetails ? (
                        <TabPanel>
                            <div className="ember-view scroll-y noscroll-x fill body scrollbox">
                                <br />
                                <div className="group">
                                    <div className="row" style={{ fontSize: "20px" }}>
                                        <label className="col-lg-3 items-label text-muted">Item:</label>
                                        <label className="col-lg-7">{itemDetails?.title}</label>
                                    </div>
                                    <div className="row">
                                        <label className="col-lg-3 items-label text-muted">Ingredient:</label>
                                        <label className="col-lg-7">{itemDetails?.isIngredient ? "True" : "False"}</label>
                                    </div>

                                    <div className="row">
                                        <label className="col-lg-3 items-label text-muted">Floating:</label>
                                        <label className="col-lg-7">{itemDetails?.isFloating ? "True" : "False"}</label>
                                    </div>

                                    <div className="row">
                                        <label className="col-lg-3 items-label text-muted">Pack Unit</label>
                                        <label className="col-lg-7">{itemDetails?.packUnitTitle}</label>
                                    </div>
                                    <div className="row">
                                        <label className="col-lg-3 items-label text-muted">Item Wt.</label>
                                        <label className="col-lg-7">
                                            {itemDetails?.itemWeightQuantity}&nbsp;
                                            {itemDetails?.itemUnitTitle}
                                        </label>
                                    </div>
                                    <div className="row">
                                        <label className="col-lg-3 items-label text-muted">Box Weight</label>
                                        <label className="col-lg-7">
                                            {itemDetails?.weightValue} {itemDetails?.weightUnitTitle}
                                        </label>
                                    </div>

                                    <div className="row">
                                        <label className="col-lg-3 items-label text-muted">SKU</label>
                                        <label className="col-lg-6">{itemDetails?.sku}</label>
                                    </div>
                                    <div className="row">
                                        <label className="col-lg-3 items-label text-muted">HSN Code</label>
                                        <label className="col-lg-7">{itemDetails?.hsnSac}</label>
                                    </div>
                                    <div className="row">
                                        <label className="col-lg-3 items-label text-muted">Tax Preference</label>
                                        <label className="col-lg-6 col-md-6 col-sm-6 col-6">{itemDetails?.isTaxable ? "Taxable" : "Non-Taxable"}</label>
                                    </div>

                                    {itemDetails.openingStock ? (
                                        <div className="row">
                                            <label className="col-lg-3 items-label text-muted">Open Stock Box Qty</label>
                                            <label className="col-lg-6 col-md-6 col-sm-6 col-6">{itemDetails.openingStock}</label>
                                        </div>
                                    ) : (
                                        <></>
                                    )}

                                    {itemDetails.openingStockValue ? (
                                        <div className="row">
                                            <label className="col-lg-3 items-label text-muted">Opening Stock Value</label>
                                            <label className="col-lg-6 col-md-6 col-sm-6 col-6">{itemDetails.openingStockValue}</label>
                                        </div>
                                    ) : (
                                        <></>
                                    )}

                                    {itemDetails.brandTitle ? (
                                        <div className="row">
                                            <label className="col-lg-3 items-label text-muted">Category</label>
                                            <label className="col-lg-6 col-md-6 col-sm-6 col-6">{itemDetails.brandTitle}</label>
                                        </div>
                                    ) : (
                                        <></>
                                    )}

                                    {itemDetails.isTaxable ? (
                                        <>
                                            <div className="row">
                                                <label className="col-lg-3 items-label text-muted">Intra State Tax</label>
                                                <label className="col-lg-6">{itemDetails !== null ? itemDetails.taxTitleIntrastate : "-"}</label>
                                            </div>
                                            <div className="row">
                                                <label className="col-lg-3 items-label text-muted">Inter State Tax</label>
                                                <label className="col-lg-6">{itemDetails !== null ? itemDetails.taxTitleInterstate : "-"}</label>
                                            </div>
                                        </>
                                    ) : (
                                        <></>
                                    )}

                                    {itemDetails.reorderPoint ? (
                                        <div className="row">
                                            <label className="col-lg-3 items-label text-muted">Reorder Point</label>
                                            <label className="col-lg-6 col-md-6 col-sm-6 col-6">{itemDetails.reorderPoint}</label>
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                                <br />
                                <div className="row">
                                    {itemDetails.sellingPriceValue ? (
                                        <div className="col-6">
                                            <label className="pb-3 font-medium">Sales Information</label>
                                            <div className="group">
                                                <div className="row">
                                                    <label className="col-lg-4 items-label text-muted">Selling Price</label>
                                                    <label className="col-lg-5">
                                                        {itemDetails.sellingCurrencySymbol}
                                                        {itemDetails.sellingPriceValue}
                                                    </label>
                                                </div>
                                                <div className="row">
                                                    <label className="col-lg-4 items-label text-muted">Account</label>
                                                    <label className="col-lg-5">{itemDetails.sellingAccountTitle}</label>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                    {itemDetails.purchasePriceValue ? (
                                        <div className="col-6">
                                            <label className="pb-3 font-medium">Purchase Information</label>
                                            <div className="group">
                                                <div className="row">
                                                    <label className="col-lg-4 items-label text-muted">Purchase Price</label>
                                                    <label className="col-lg-5">
                                                        {itemDetails.purchaseCurrencySymbol}
                                                        {itemDetails.purchasePriceValue}
                                                    </label>
                                                </div>
                                                <div className="row">
                                                    <label className="col-lg-4 items-label text-muted">Account</label>
                                                    <label className="col-lg-5">{itemDetails.purchaseAccountTitle}</label>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>

                                <br />

                                <div>
                                    <div className="pb-3 font-size-18">Warehouse Info</div>
                                    <table id="ember7912" className="customTable itemViewTable">
                                        <thead>
                                            <tr>
                                                <th>Warehouse Title</th>
                                                <th>Current Stock Pack Qty</th>
                                                <th>Current Stock Open Qty</th>
                                                <th>Opening Stock Pack Qty</th>
                                                <th>Opening Stock Open Qty</th>
                                                <th>Opening Stock Value</th>
                                            </tr>
                                        </thead>

                                        {valueLoading && (
                                            <tbody>
                                                {itemDetails1.map((item, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td>{item.warehouseTitle}</td>
                                                            <td>{item.currentStockBoxQuantity}</td>
                                                            <td>{item.currentStockOpenQuantity}</td>

                                                            <td>{item.openingStockBoxQuantity}</td>
                                                            <td>{item.openingStockOpenQuantity}</td>

                                                            <td>{item.openingStockValue}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        )}
                                    </table>
                                </div>
                            </div>
                        </TabPanel>
                    ) : (
                        "..loading"
                    )}
                    <TabPanel>
                        <div className="ember-view scroll-y noscroll-x fill body scrollbox py-3">
                            <table>
                                {logData.length === 0 ? (
                                    "No Changes Found"
                                ) : (
                                    <thead>
                                        <tr>
                                            <th style={{ width: "90px" }}> Date </th>
                                            <th>Changes</th>
                                        </tr>
                                    </thead>
                                )}
                                {logData.length >= 1 && (
                                    <tbody>
                                        {logData?.map((history, j) => {
                                            return (
                                                <tr key={j}>
                                                    <td style={{ verticalAlign: "top" }}>
                                                        {history?.transactionDate?.substring(0, 10)}
                                                        :&nbsp;&nbsp;
                                                        <br />
                                                        Time:
                                                        {history?.transactionDate?.split("T")[1].substring(0, 5)}
                                                    </td>

                                                    <td>
                                                        <div dangerouslySetInnerHTML={{ __html: history?.message.replaceAll("\n", "<br />").replaceAll("\t", "&nbsp;&nbsp;&nbsp;&nbsp;") }} />
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </TabPanel>

                    {/* (loginData1.username === "Gajendra" || loginData1.username === "sangeeta" || loginData1.username === "KPIS_DEVELOPER") &&  */}
                    <TabPanel> 
                        <div className="ember-view scroll-y noscroll-x fill body scrollbox py-3">
                            <table>
                                <tbody>
                                    {logHistoryDetails && logHistoryDetails.stock && logHistoryDetails.stock.length > 0 ? (
                                        <tr>
                                            <td>
                                                <pre>{JSON.stringify(logHistoryDetails.stock, null, 2)}</pre>
                                            </td>
                                        </tr>
                                    ) : (
                                        <tr>
                                            <td colSpan="100%" style={{ textAlign: 'center', padding: '20px' }}>
                                            No Records Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </TabPanel>
                    {/* // } */}
                </Tabs>
            </div>
            <Toaster />
        </>
    );
};
export default ViewItem;